// extracted by mini-css-extract-plugin
module.exports = {"actionTitle":"CS50ExerciseSets_actionTitle__3j5rZ","exercisesCount":"CS50ExerciseSets_exercisesCount__3IfzF","plusIcon":"CS50ExerciseSets_plusIcon__3oCRP"};